// extracted by mini-css-extract-plugin
module.exports = {"route":"route-2soUH","route__icon":"route__icon-CAPNx","passengers":"passengers-2uLo5"};